import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendAmWelcomeEmailTrial} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useSendAmTrialWelcomeEmail = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(
        (requestBody: number[]) => apiDispatch(sendAmWelcomeEmailTrial({userId, requestBody})),
        [userId, apiDispatch],
    );

    return useCommonEventHook({eventAction});
};
